/**
 * @file ファイルドロップ
 */
'use strict';

import ApplyClass from '../../Utils/ApplyClass';
import Common from '../../Utils/Common';
import Validate from './Validate';
import DeleteImage  from './DeleteImage';

/**
 * @classname FileUpload
 * @classdesc ファイルドロップ
 */
export default class FileUpload {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log('FileUpload.constructor');
		this._$e = $e;
		this._controller = controller;
		this._$blockFileUpload = $e.closest('.form-group--upload');
		this._$inputFile = this._$blockFileUpload.find('input[type=file]');
		this._$inputFileWrap = this._$blockFileUpload.find('.block--file-input');
		this._$upload_name = $('.text--upload-name');
		this._$preview = this._$blockFileUpload.find('.image-box--preview');
		this._$not_preview_text = this._$blockFileUpload.find('.text--not-preview');
		this._$delBtn = $('.btn--image-del');
		this._$file_name = $('#file_name')
		this._inputFile = '<input class="validate" type="file" accept="application/pdf" style="display:none;" data-validate="empty">';
		this._orientation = 1;
		this._upload = false;
		// this._$e.on('dragover', e => this.onDragover(e));
		// this._$e.on('dragleave', () => this.onDragleave());
		//this._$e.on('drop', e => this.onDrop(e));
		this._$e.on('click', e => this.onClick(e));
		this._$inputFile.on('change', e => this.onChange(e));
		//this._controller.on('uploadAttachmentComplete', () => this.onUploadAttachmentComplete());
		//this._controller.on('deleteAttachmentComplete', () => this.onDeleteAttachmentComplete());

		this._$delBtn.on('click', e => this.onClearButtonClick());
		this._$file_name.on('change', e => this.onFileNameChange());
	};

	/**
	 * クリックのコールバック
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	onClick(e){
		console.log('FileUpload.onClick');
		e.preventDefault();
		e.stopPropagation();
		console.log('inputFile:');
		this._$inputFile.click();
	}
	/**
	 * ドラッグオーバーのコールバック
	 *
	 * @memberof FileUpload
	 * @param {object} e - イベント
	 * @return {undefined}
	 */
	onDragover(e) {
		e = e.originalEvent;
		e.dataTransfer.dropEffect = 'copy';
		e.preventDefault();
		this._$e.addClass('dragover');
	};


	/**
	 * ドラッグリーブのコールバック
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	onDragleave() {
		this._$e.removeClass('dragover');
	};


	/**
	 * ドロップのコールバック
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	// onDrop(e) {
	// 	console.log('FileUpload.onDrop');
	// 	e = e.originalEvent;
	// 	e.preventDefault();
	// 	this._$e.removeClass('dragover');
	// 	this._files = e.dataTransfer.files;
	// 	if(this._files.length > 1) {
	// 		Common.showErrorModal('画像は1枚ずつあげてください。');
	// 		return;
	// 	}
	// 	const file = this._files[0];
	// 	const maxMB = window.const.FILE.MAX_MB;
	// 	const maxSize = maxMB * 1024 * 1024;
	// 	if (file.size > maxSize) {
	// 		Common.showErrorModal(`画像サイズは${maxMB}MB以下の必要があります。`);
	// 		return;
	// 	}
	// 	this._upload = true;
	// 	this._controller.uploadImage(file);
	// };


	/**
	 * ファイル変更のコールバック
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	onChange(e) {
		console.log('FileUpload.onChange');
		const file = e.target.files[0];
		const maxMB = window.const.FILE.MAX_MB;
		const maxSize = maxMB * 1024 * 1024;
		if (file.size > maxSize) {
			Common.showErrorModal(`画像サイズは${maxMB}MB以下の必要があります。`);
			//this.onDeleteAttachmentComplete();
			this.onClearButtonClick();
			return;
		}
		this._upload = true;

		if(this._$preview.length > 0) {
			if (file && file.type !== 'application/pdf' && file.type !== 'image/heic' && file.type !== 'application/heic') {
				const reader = new FileReader();
				reader.onload = (event) => {
					this._$preview.removeClass('hide');
					this._$preview.find('.image').attr('src', event.target.result);
					this._$not_preview_text.addClass('hide');
				};
				reader.readAsDataURL(file);
			} else {
				this._$preview.find('.image').attr('src', '#');
				this._$not_preview_text.removeClass('hide');
			}
		}else{
			//const fileName = $('#file_name').val();
			// const reader = new FileReader();
			// reader.onload = this._controller.uploadAttachment(file,this._userId,fileName);
		}
		this.onUploadAttachmentComplete(file.name)
	};

	/**
	 * ファイル名の表示
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	onUploadAttachmentComplete(filename) {
		if(!this._upload) return;
		console.log('FileUpload.onUploadAttachmentComplete');
		//const attachmentData = this._controller._attachmentData;
		//this._$upload_name.text(`${attachmentData.file_name}`)


		if(this._$file_name.val() !== undefined) {
			const fileExtension = filename.split('.').pop();
			this._$upload_name.text(this._$file_name.val() + '.' + fileExtension)
		}else{
			this._$upload_name.text(filename)
		}
		this._$delBtn.removeClass('hide')
		this._$e.closest('.form-group').find('.error-tip').removeClass('show').find('.error-tip-inner').text('');
	};

	/**
	 * 画像の表示
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	// onUploadImageComplete() {
	// 	if(!this._upload) return;
	// 	console.log('FileUpload.onUploadImageComplete');
	// 	this._$blockFileUpload.removeClass('uploading');
	// 	const imageData = this._controller._imageData;
	// 	console.log(imageData);
	// 	let img = `<div class="upload-image-wrap"><div class="upload-image" style="background: #f2f2f2 url(${imageData.url}) no-repeat 50% 50%/contain;"></div><a href="javascript:void(0);" class="anchor anchor--delete-image" data-image-id="${imageData.portfolio_id}"><span>&times;</span></a></div>`;
	// 	//this._$photoArea.html(img);
	// 	this._$e.closest('.form-group').find('.error-tip').removeClass('show').find('.error-tip-inner').text('');
	// 	this._$e.closest('.form-group').find('.input-image').val(imageData.url);
	// 	this._$inputFileWrap.html(this._inputFile);
	// 	this._$inputFile = this._$blockFileUpload.find('input');
	// 	this._$inputFile.on('change', e => this.onChange(e));
	// 	ApplyClass.apply(Validate, this._$inputFile, [this._$inputFile, this._controller]);
	// 	const $deleteImage = $('.anchor--delete-image');
	// 	$deleteImage.off();
	// 	$deleteImage.each((idx, e) => {
	// 		const $e = $(e);
	// 		ApplyClass.apply(DeleteImage, $e, [$e, this._controller])
	// 	});
	// 	this._upload = false;
	// };


	/**
	 * ファイルの削除
	 *
	 * @memberof FileUpload
	 * @return {undefined}
	 */
	// onDeleteAttachmentComplete() {
	// 	console.log('FileUpload.onDeleteAttachmentComplete');
	// 	this._$inputFileWrap.html(this._inputFile);
	// 	this._$inputFile = this._$blockFileUpload.find('input[type=file]');
	// 	this._$inputFile.on('change', e => this.onChange(e));
	// 	ApplyClass.apply(Validate, this._$inputFile, [this._$inputFile, this._controller]);
	// };

	/**
	* 選択中のファイルを選択解除する
	*
	* @memberof FileUpload
	* @return {undefined}
	*/
	onClearButtonClick() {
		console.log('FileUpload.onClearButtonClick')
		this._$inputFile.val(null)
		this._$upload_name.text('選択されていません')
		this._$delBtn.addClass('hide')
		if(this._$preview.length > 0) {
			this._$preview.addClass('hide');
			this._$preview.find('.image').attr('src', '');
			this._$not_preview_text.addClass('hide');
		}
		this._upload = false
	}

	/**
	* ファイル名が変更されたら、プレビューに反映する
	*
	* @memberof FileUpload
	* @return {undefined}
	*/
	onFileNameChange() {
		if(!this._upload) return;
		const filename = this._$file_name.val()
		if(filename !== '' && filename !== undefined) {
			const fileExtension = this._$upload_name.text().split('.').pop();
			this._$upload_name.text('')
			this._$upload_name.text(filename + '.' + fileExtension)
		}
	}
}
